<template>
  <div>
    <b-form>
      <span>Pilih Bidang Studi </span>
      <b-form-select style="width: 50%" v-model="selected" :options="options" class="ml-6"></b-form-select>
    </b-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selected: null,
      options: [
        { value: null, text: '--Pilih Bidang Studi--' },
        { value: 'Bidang Studi Kepemimpinan dan Kejuangan', text: 'Bidang Studi Kepemimpinan dan Kejuangan' },
        { value: 'Bidang Studi Strategi', text: 'Bidang Studi Strategi' },
        { value: 'Bidang Studi Manajemen dan Logistik', text: 'Bidang Studi Manajemen dan Logistik' },
        { value: 'Bidang Studi Ilmu Pengetahuan dan Teknologi', text: 'Bidang Studi Ilmu Pengetahuan dan Teknologi' },
        { value: 'Bidang Studi Manajemen dan Logistik', text: 'Bidang Studi Manajemen dan Logistik' },
        { value: 'Bidang Studi Operasi', text: 'Bidang Studi Operasi' }
    ]
    }
  }
 }
</script>